"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
const _tagged_template_literal = require("@swc/helpers/_/_tagged_template_literal");
function _templateObject() {
    const data = _tagged_template_literal._([
        "\n  fragment EditorialCategory on EditorialLandingPage {\n    landingPageId\n    imageUrl\n    thumbnailUrl\n    description\n    themeTag\n    link {\n      relativeUrl\n    }\n  }\n"
    ]);
    _templateObject = function() {
        return data;
    };
    return data;
}
function _templateObject1() {
    const data = _tagged_template_literal._([
        "\n  ",
        "\n  ",
        "\n  fragment EditorialCategoryPage on Application {\n    editorialLandingPage(channelType: Web, landingPageId: $pageId) {\n      landingPageId\n      imageUrl\n      thumbnailUrl\n      description\n      themeTag\n      editorialItems {\n        ...EditorialPage\n      }\n      backgroundStorybookColor\n      headlineStorybookColor\n      themeItems @include(if: $includeThemeItems) {\n        ...EditorialCategory\n      }\n    }\n    rootEditorialLandingPage: editorialLandingPage(channelType: Web, landingPageId: $landingPageId)\n      @include(if: $includeRoot) {\n      themeItems {\n        ...EditorialCategory\n      }\n    }\n  }\n"
    ]);
    _templateObject1 = function() {
        return data;
    };
    return data;
}
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.editorialCategoryPageFragment = void 0;
var _fetching = require("@ori/fetching");
var _editorialPageFragment = require("./editorialPageFragment");
const editorialCategoryFragment = (0, _fetching.gql)(_templateObject());
const editorialCategoryPageFragment = exports.editorialCategoryPageFragment = (0, _fetching.gql)(_templateObject1(), editorialCategoryFragment, _editorialPageFragment.editorialPageFragment);
